import React from "react";
import "../styles/offerModal.css";
import { isSpecialOfferActive } from "../utils/offerDateUtil";

const OfferNewsTicker = ({ onOpenModal }) => {
  const handleOpen = () => {
    if (typeof onOpenModal === "function") {
      onOpenModal();
    } else {
      window.dispatchEvent(new CustomEvent("vk_open_offer_modal"));
    }
  };

  if (!isSpecialOfferActive()) return null;

  const tickerContent = [
    {
      category: "Mandala Stencils",
      deals: "Buy 2 ➔ 1 Bridal Cone Free  •  Buy 3 ➔ 2 Free  •  Buy 5 ➔ 5 Free!",
    },
    {
      category: "Bridal Stencils",
      deals: "Every Bridal Stencil ➔ 1 Henna Dip Free!",
    },
  ];

  return (
    <div className="vk-news-ticker-container">
      {/* Pinned News Tag on Left */}
      <div className="vk-news-ticker-badge" onClick={handleOpen} title="Click to view all offers">
        <span className="vk-pulse-dot" />
        <span>OFFERS (OCT 6 – NOV 6)</span>
      </div>

      {/* Marquee Track */}
      <div className="vk-news-ticker-track-wrap" onClick={handleOpen} title="Click to view offer details">
        <div className="vk-news-ticker-track">
          {/* First iteration */}
          {tickerContent.map((item, index) => (
            <span key={`t1-${index}`} className="vk-ticker-item">
              <span className="vk-ticker-highlight">{item.category}:</span>
              <span>{item.deals}</span>
              <span className="vk-ticker-separator">✦</span>
            </span>
          ))}

          {/* Repeat for seamless infinite loop */}
          {tickerContent.map((item, index) => (
            <span key={`t2-${index}`} className="vk-ticker-item">
              <span className="vk-ticker-highlight">{item.category}:</span>
              <span>{item.deals}</span>
              <span className="vk-ticker-separator">✦</span>
            </span>
          ))}

          {/* Repeat third time for wide screens */}
          {tickerContent.map((item, index) => (
            <span key={`t3-${index}`} className="vk-ticker-item">
              <span className="vk-ticker-highlight">{item.category}:</span>
              <span>{item.deals}</span>
              <span className="vk-ticker-separator">✦</span>
            </span>
          ))}
        </div>
      </div>

      {/* Action button on right */}
      <button className="vk-ticker-action-btn" onClick={handleOpen}>
        <span>View Details</span>
        <i className="fa fa-arrow-right" style={{ fontSize: "0.75rem" }} />
      </button>
    </div>
  );
};

export default OfferNewsTicker;
